import React from 'react'
import {
    Button,
    DialogActions,
    Grid,
    TextField,
    makeStyles
} from '@material-ui/core'

import AdminModal from '../components/admin/AdminModal'

import { useValidation } from 'components'
import Auth from '@aws-amplify/auth'

const useStyles = makeStyles({
    root: {
        padding: 20
    },
    text: {
        textAlign: 'center'
    },
    buttonContainer: {
        paddingTop: 20,
        borderTop: '1px solid #dee2e6'
    },
    resetButton: {
        color: '#fff'
    }
})

function ActionButtons({ onSubmit }) {
    const classes = useStyles()
    return (
        <DialogActions>
            <Grid
                container
                className={classes.buttonContainer}
                justify="flex-end"
                spacing={2}
            >
                <Grid item>
                    <Button
                        onClick={onSubmit}
                        variant="contained"
                        color="primary"
                        className={classes.resetButton}
                    >
                        Reset
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    )
}

function NewPasswordModal(props, ref) {
    const [open, setOpen] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState("")
    const [values, setValues] = React.useState({
        newPassword: '',
        newPasswordConfirm: ''
    })
    const [user, setUser] = React.useState({})

    const { validate, errors, ifError, reset: resetValidation } = useValidation(
        {
            newPassword: ['required', 'password'],
            newPasswordConfirm: [
                'required',
                { type: 'match', property: 'newPassword' }
            ]
        }
    )

    const onChange = React.useCallback(
        e => {
            const value = e.target.value
            setValues({
                ...values,
                [e.target.name]: value
            })
            resetValidation()
        },
        [values, resetValidation]
    )

    const onSubmit = React.useCallback(async e => {
        e.preventDefault()

        if (!validate(values)) {
            return
        }
        try {
            await Auth.completeNewPassword(user, values.newPassword, {})
        } catch (error) {
            setErrorMessage(error.message)
        }
    }, [values])

    React.useImperativeHandle(ref, () => ({
        open: user => {
            setUser(user)
            setOpen(true)
        }
    }))

    const classes = useStyles()

    return (
        <AdminModal
            open={open}
            title="Please set a new password."
        >
            <Grid container spacing={2} className={classes.root}>
                {errorMessage}
                <Grid item xs={12} className={classes.text}>
                    <TextField
                        label="New Password"
                        name="newPassword"
                        value={values.newPassword}
                        onChange={onChange}
                        type="password"
                        error={errors.newPassword}
                        helperText={ifError(
                            'newPassword',
                            'Please fill in your new password'
                        )}
                        variant="outlined"
                        color="primary"
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Confirm Password"
                        name="newPasswordConfirm"
                        value={values.newPasswordConfirm}
                        onChange={onChange}
                        type="password"
                        error={errors.newPasswordConfirm}
                        helperText={ifError(
                            'newPasswordConfirm',
                            'Please confirm your new password'
                        )}
                        variant="outlined"
                        color="primary"
                        fullWidth
                        size="small"
                    />
                </Grid>
            </Grid>
            <ActionButtons onSubmit={onSubmit}/>
        </AdminModal>
    )
}

export default React.forwardRef(NewPasswordModal)
